export const en = `#English#
#Basket
currencyRateInfo|Please note that payment depends <br /> on exchange rates
cancelWithNoPenalty|Free booking cancellation
captionTextWaitingFirstPartPeriodUpper|Please wait, we are searching for flight options for the selected tour.
searchUpper|Search
basketUpper|Shopping cart
tourCost|Tour cost
commission|Commission
yourDiscount|Your discount
agencies|Agencies
additionalServicesCost|Cost of additional services
requiredServicesCost|Cost of compulsory services
agreeWithOrderConditions|I agree with the booking conditions
summaryUpper|Total
priceChangedOn|The price has changed for
buyUpper|Buy
servicesForHotels|Services for hotels
insuranceUpper|Insurance
editUpper|Change
seeМoreОptions|show more options
moreОptions|more options
requiredServicesUpper|Compulsory services
additionalServicesUpper|Additional services
sexFemaleUpper|F
sexMaleUpper|M
adultShort|ad.
childShort|ch.
adult|adult
adults2|adults
child|child
infant|infant
dataIsExpired|Tour data expired, please repeat the search
dateIsNoTour|There is no tour on this date
notRequiredUpper|Not required
dayShort|d.
resetFlightsUpper|Reset
fromUpper|Origin
infoBlockPartOne|To continue the reservation is necessary to choose the actual airfare.
infoBlockPartTwo|After that, the cost of the tour in the basket will be calculated based on the selected airfare.
departureDateUpper|Departure date
arrivalDateUpper|Arrival date
adultChildInfantUpper|Adults / Childs
flightUpper|Flight
selectFlightsUpper|By choosing this flight the cost of the tour will change to
baggageRestrictionUpper|Baggage
carryOnRestrictionUpper|Hand luggage
timeLimiteUpper|Time-limit:
perhapsBaggageDifferentFareUpperP1|Possibly luggage
perhapsBaggageDifferentFareUpperP2|in another tariff
directsUpper|Direct
oneDirectUpper|1 change
twoOrMoreDirectUpper|2 or more
withoutDirectUpper|No connections
baggageYesNoUpper|Baggage
withBaggageUpper|With baggage
withoutBaggageUpper|Without baggage
btnTextTariffChangeBaggageUpper|Change tariff
departureAirportUpper|Departure airport
transitAirportUpper|Transit airport
arrivalAirportUpper|Arrival airport  
airlinesUpper|Airlines
economyUpper|Economy
premiumEconomyUpper|Premium Economy
businnessUpper|Business
firstUpper|First
decreaseDurationOfResidence|The flight you have chosen arrives later than we planned. Reduce length of stay by {0} {1}? The cost of the tour is automatically recalculated taking into account changes.
increaseDurationOfResidence|The flight you have chosen arrives earlier than we planned. Length of stay increases by {0} {1}. The cost of the tour is automatically recalculated taking into account changes.
startDateOfYourStayHasChanged|Taking into account your chosen flight "{0}/{1}", the date of arrival at the hotel and the duration of stay have changed.
drawYourAttention|Draw your attention to:
changedAirportsMessage|– the departure/arrival airport has changed
changedArrivalAirportMessage|– The arrival airport has changed. After booking, please contact your manager to clarify details on transfers
changedNoLuggageMessage|– the entire flight or part of the flight segments is carried out at a baggage-free fare
warningAirportsChangedMessageUpper|Attention! The airports of departure/arrival have been changed. Please contact your manager after booking to clarify transfer details.
warningTechnicalProblemsMessageUpper|We were unable to update the price of the regular flight.{0}You can proceed with your tour booking. After booking a tour,{1} the cost and details of the regular flight may change.{2}Our manager will contact you to clarify the details.
warningTechnicalProblemsMessageOrderUpper|We were unable to update the price of the regular flight.{0}Tour prices and regular flight details are subject to change.{1}Our manager will contact you to clarify the details.
warningTechnicalProblemsMessageWithAutomaticFlightSelectionUpper|For technical reasons, we could not book the first suitable flight, we are trying to book the next one.
ItIsNotPossibleBookFlightsTheCurrentCostUpper|We could not find a suitable flight. {0} You can continue booking the tour. {1} After booking the tour, its cost and details of the regular flight may change. {2} Our manager will contact you to clarify the details.
warningNoFlightsUpper|No suitable scheduled flights found. You can change your search criteria{0}and try to find other flights or continue your booking.{1}After booking a tour, the cost and details of the regular flight may change.{2}Our manager will contact you to clarify the details.
closedModalFormWithRequiredFlightsUpper|Attention! Flight has not been selected!{0}Click "OK" and repeat the selection using the "Get other options" button, otherwise the booking process will continue without selecting and booking tickets in GDS. By continuing booking without choosing a ticket, you agree that the details of the flight and its cost may change. To clarify the details and book a flight, contact your manager.
closedModalFormWithRequiredFlightsWithAutomaticFlightSelectionUpper|You cannot proceed with your booking without choosing a regular flight.{0}When you close the screen, the flight with the minimum cost will be automatically selected.
warningModalFormWithRequiredFlightsUpper|Attention! Flight has not been selected!{0}Click "Cancel" and repeat the selection using the "Get other options" button, otherwise the booking process will continue without selecting and booking tickets in GDS. By continuing booking without choosing a ticket, you agree that the details of the flight and its cost may change. To clarify the details and book a flight, contact your manager.
warningCouldNotActualizeFlightOrHotelPriceFromRemoteSystemUpper|It is impossible to book at this price, repeat search query and select the appropriate option.
seniorManagerUpper|Senior manager
reservationBranchUpper|Reservation branch
chooseManagerUpper|Select manager
selectBranchUpper|Select branch
noFlightsSatisfytingFiltersPartOneUpper|We found
noFlightsSatisfytingFiltersPartTwoUpper|flight(s), but none match the specified filters.
acceptsConditionsNotifyText|Confirm your agreement with the booking conditions.
touristsDataValidNotifyText|Fill in the required tourist fields.
touristsAgeDataValidNotifyText|There must be at least one adult traveler when booking.
btnTextSortCheapUpperTitlesUpper|Cheap first
btnTextSortFastUpperTitleUpper|Fast first
btnTextSortOptimalUpperTitleUpper|Optimal
textSortUpperTitleUpper|Sort result by
touroperatorsFlightTitleUpper|Touroperator's flight
travelTimeTitle|Travel time
durationTransfers|Duration of transfers
timeTitle|Time
btnTextTariffChooseUpper|Choose tariff
timeLimitTextUpper|Time-limit for selected flight
timeLimitTextUpper2|Time limit up to
tariffChangedTextUpper|Tariff changed
notIncludedTaxesFeesUpper|Taxes and fees not included in the price (for all tourists, for the entire stay):
environmentalFeeUpper|Green tax
cityTaxUpper|City tax
resortFeeUpper|Resort fee
luxuryTaxUpper|Luxury tax
hotelFeeUpper|Hotel fee
cleaningFeeUpper|Cleaning fee
transferFeeUpper|Transfer to hotel
serviceFeeUpper|Service fee
occupancyTaxUpper|Occupancy tax
electricityFeeUpper|Electricity fee
vatUpper|VAT
dublicateMessagePart0|Attantion! For the check in date 
dublicateMessagePart1|to the country
dublicateMessagePart2|for the tourist
dublicateMessagePart3|there are already booked reservations:
dublicateMessagePart4|If you are sure that it is not an equal reservation so push the «OK» button again.
dublicateMessagePart5|When you clicked button «Cancel» reservation will not be made.
accommodation|Accommodation
included|Included
notIncluded|not included
FiltersSelectedNotApplied|Filters were selected but not applied.
direct|direct
directFlight|direct flight
returnFlight|return flight
transfer|Transfer
transferTransfer|Transfer
busTransfer|Bus transfer
railwayTransfer|Railway crossing
touristData|Tourist data
tourists|Tourists
visaApplication|Visa application
enterData|Enter data
main|Main
handOnly|Hand luggage only
toCart|To cart
selectTariffUpper|By choosing this tariff the cost of the tour will change to
dogovorComment|Comments on the ticket
customer|Customer
accommodationFoodOption|Option accommodation / meal
additionally|Additionally
wrongValue|Incorrect
checkInAt|check in at
checkOutBefore|check out before
flightDetails|flight details
totalToPay|TOTAL to pay
transit|transit
operatorFlight|Air flight based on the block of seats of the tour operator
GDSFlight|Flight from online availability in GDS
tariffConditions|Tariff conditions
moreSuggestions|More options
main2|Home
searchResults|Searching results
selectedTour|Selected tour
failedUpdateFlightRemoteProviderExchangeRates|Failed to update flight from external provider due to lack of exchange rates.
taxInfoUpdate|Information about penalties has been updated.
taxInfo|Please note that there is information about penalties.
noSeatsUpper|There are no vacancies for the selected destination for these dates.
noFaresAvailableFlight|Sorry, no other fares are available for this flight
otherFlights|Other flights
departureTime|Departure time
showAllFlights|Show all flights
minimizeAllFlights|Minimize all flights
departureFromAirport|Departure from the airport
arrivalInAirport|Arrival at the airport
byLocalTime|by local time
in|at
transfer|Transfer
airport|airport
loadAnotherAirTariffPart1Upper|There are no seats available for the 
loadAnotherAirTariffPart2Upper| class. Do you want to search for tickets for another class?
receiveAgreedUpper|I agree to receive marketing emails
wrongHowDidYouHearUpperTitle|Incorrect "How did you hear about us?"
wrongResidenceRegionUpperTitle|Incorrect format "Region of residence"
howDidYouHearUpperTitle|How did you hear about us?
residenceRegionUpperTitle|Region of residence
receiveAgreedUpper|I agree to receive marketing emails
failedFindTransfer|Failed to find transfer (the basket cannot be created). Please contact the tour operator.
promocode|Promocode
enterPromocode|Enter promocode:
enterDiscountCard|Enter discount card:
selectDiscountType|Select discount type:
promocodeNotFound|* Promocode not found
discountCardNumberIncorrect|* Incorrect discount card number
tourInfo|Tour information

#Buyers details in basket
buyerDetails|Buyer details
buyerType|Buyer type
touristNumber|Tourist
TravelAgent|Travel agency
ReservationTourist|Tourist from the application
PhysicalPerson|Individual
IndividualEntrepreneur|Individual entrepreneur
LegalPerson|Legal entity
FullName|Full name
FullNameDirector|Full name of manager
Birthday|Birthdate
Address|Address
LegalName|Official name
Phone|Phone
Email|E-mail
CountryKey|Country
INN|TIN
DocumentType|Document type
PassportSer|Passport series
PassportNum|Passport number
ContractDate|Date of the contract with the client
ContractNumber|Contract number with the client
ContractPrice|Contract amount with client
Other|Other
Passport|Passport
ForeignPassport|International passport
BirthCertificate|Birth certificate
ServicePassport|Service passport
DiplomaticPassport|Diplomatic passport
IdCard|ID card
TouristNotSelected|Tourist not selected

#Search
quotaForServiceIsOutUpper|Service quota is over
countryAnnotationUpper|Tips for travelling to the selected country
incorrectChildrenInf|Age of children does not match the permitted children age range for the selected accommodation. (see Services: Accomodation)
adultsCountOverServiceLimitUpper|Adult tourists quantity exceeds the service limit
at|for
tourProgramVariantsSearch|Tour search
hotelsVariantsSearch|Hotels search
quotasVariantsSearch|Hotels availability
errorUpper|Error
licenseExpired|License expired.
noToursFound|No tours found with the selected search options. Please change search parameters, availability status values, change dates or duration.
departFrom|From
departTo|To
resortOrHotelName|Resort or hotel name
tourType|Tour type
daysCount|Number of days
nightsCount|Number of nights
nightsHotel|Stay nights
inHotel|in hotel
adults|Adults
childs|Children
nightsFrom|min
nightsTo|max
city|City
hotel|Hotel
resort|Resort
category|Category
priceUpper|Price
from|from
to|to
actualFiltersServiceUnavailable|Actual filter service is unavailable.
systemTemporarilyUnavailable|System is temporarily unavailable
actualFiltersServiceCacheIsNotInitialized|Initialization of the actual filters service cache is in progress (30-60min).
serviceIsUnavailable|Service is unavailable.
cacheIsNotInitialized|Cache is not initialized. Try reloading the page in a minute.
quotasServiceIsUnavailable|The quota service is not available. Check your settings.
searchServiceIsUnavailable|Search service is not available.
searchServiceCacheIsNotInitialized|Search service cache is initializing (30-60 min).
ratesDidntFound|Attention! The national currency or cross-currency exchange rates are not added. Please inform the administrator.
bascketCurrencyDidntFound|Error in setting "Displaying prices in the basket and personal account in any currency"
rate|Currency
requestProcessingError|An error occurred while processing the request. Try reloading the page
duration|Duration
flight|Flight
tourBookingConditions|Tour Booking terms and conditions
offerAgreement|Offer agreement
submittingAgreePrivacyPolicy|Privacy policy
termsTariffs|Terms of application of tariffs
clickBookAccept|By clicking book I accept
сlickRegistrationAccept|By clicking registration I accept
giveConsentSpecifiedPersonsForProcessingPersonalData|and I give my consent and other persons indicated in the voucher to the processing of personal data, as well as their transfer to third parties providing these services.
variants|Details
minimize|Collide
searchResultsAreExpired|Search results are out of date, try your search one more time.
pansionUpper|Meal
find|Search
tourProgram|Tour program
clearFilters|Clear filters
cityUpper|City
resortUpper|Resort
hotelUpper|Hotel
combinationUpper|Selected combination
showSelectedUpper|Show selected
groupByUpper|Group by:
groupCountriesTitle|Сountries
groupResortsTitle|Resorts
groupCitiesTitle|Cities
groupNoneTitle|Not specified
hotelCombinationUpper|Selected hotel combination
hotelCombinationDescr|Only those tours in which the selected combination of hotels occurs will be displayed
hotelTypeCombinationUpper|Selected combination of hotel types
hotelTypeCombinationDescr|Only those tours in which the selected combination of hotel types occurs will be displayed
flightDepartureUpper|Departure
flightArrivalUpper|Arrival
airlineUpper|Airline
allowCombineAirlines|Allow to combine flights
allowCombineAirlinesDescr|When this attribute is selected, flights will be selected if at least one segment, are operated by the selected airline.
flightClass|Air transportation class
allowCombineTariffs|Allow to combine classes
allowCombineTariffsDescr|When this attribute is selected, flights will be selected if at least one segment of the flight is carried by the selected class.
withoutFlightUpper|Without air transportation
all|All
maximumNumberOfDates|The maximum number of dates you can select –
maximumNumberOfDurations|The maximum number of durations you can select –
groupingWarning|When grouping with a minimum price limit, it is recommended to use fewer durations
hotelDescriptionUpper|Description
infrastructureHotelUpper|Infrastructure hotel
recreationSportUpper|Recreation and sport
beachUpper|Beach
healingUpper|Healing
additionalServicesUpper|Additional services
forChildrensUpper|For childrens
excursionsUpper|Excursions
addCostUpper|AddCost
hourTextUpper|h
minutesTextUpper|min
searchingToursWithRemoteHotels|We are looking for tours with hotels from external systems
toursUpper|Tours
ticketsUpper|Tickets
whenUpper|When
periodUpper|Period
ageOfChild|Age of {}-st child
firstSetField|First set the field
youCanSelectOnlyItem|You can select only 1 item
doNotShowAgain|Do not show again
dateControlInfo|By default dates range is selected. You can select one date using the Ctrl key.
dateControlInfoInner|* you can select one date using the Ctrl key.
selecteDates|Select check-in dates
selectStartDate|Select the start date for viewing
pricingTableUpper|Pricing table
availabilityUpper|Price range
availabilityPriceRangeUpper|Specify price range:
tourOptionsUpper|Tour options
accommodationUpper|Accommodation
showForSelected|Show only available places for selected
departureUpper|Departure
arrivalUpper|Arrival
setChildAge|Set the child's age first
allOptions|All options
searchHotelsExternalSystems|Search hotels in external systems
datesTable|Dates table
discount|Discount
done|Done
okUpper|Ok
allFilters|All filters
hotelType|Hotel sign
roomFeature|Room feature
loadMore|Show more
groupTitle|Grouping by hotel
bigRowTitle|Big list
gridTitle|Tile
rowTitle|List
mapTitle|Map
moreDate|несколько дат
resetAll|Reset all
advancedSearchFilters|Advanced search filters
additionalFilters|Доп. фильтры
search|Search
noSvgSearch|Tour search
defaultYesFilter|Exist
defaultYesRequestFilter|Exist+Request
defaultAllFilter|All
hotelsAvailability|Hotels availability
seatAvailability|Seat availability
hotelsUpper|Hotels
minimalPriceUpper|Minimal price

#Transport
placesTransportTour|Places in transport on the tour
legend|Legend
busLineNumber|the row number on the bus
leftRowByWindow|LW - left row, by the window
leftRowByAisle|LA - left row, at the aisle
rightRowByAisle|RA - right row, at the aisle
rightRowByWindow|RW - right row, by the window
servicePlaceAdditionalRows|S * - service places / additional rows in large buses. Check the availability of these places additionally
isTaken|Busy
free|Free
locked|Locked
noSeatingPlan|No seating plan
seatingPlan|Seating plan

#Specials
SpecialsInformation|There is a {0}{1} discount for hotel on {2} special for bookings before {3}. The discount is included in the tour price.
SpecialsInformationWithoutDate|There is a {0}{1} discount for hotel on {2} special. The discount is included in the tour price.
SpecialsInformationPayStay|There is a Pay/Stay promotion for hotel. From {0} to {1} nights {2} {3} night for bookings before {4}.
SpecialsInformationPayStayWithoutDate|There is a Pay/Stay promotion for hotel. From {0} to {1} nights {2} {3} night.
SpecialsInformationTransfer|There is a {0}{1} discount for transfer. From {2} to {3} nights for bookings before {4}. The discount is included in the tour price.
SpecialsInformationTransferWithoutDate|There is a {0}{1} discount for transfer. From {2} to {3} nights. The discount is included in the tour price.
PayStayOperationMinus|minus
PayStayOperationPlus|plus
PayStayOperationEqual|equal
tarifInformationTitleUpper|Tariff Information

#Common
allUpper|All
day|day
night|night
day2|days
night2|nights
days|days
nights|nights
enterLogin|Enter login
enterPassword|Enter password
userName|Login
passwordUpper|Password
openDashboard|Proceed to profile
forgotPassword|Forgot password?
agencyRegistration|Register an agency
touristRegistration|Register a tourist
enter|OK
logout|Log out
nameUpper|Name
surnameUpper|Surname
phoneNumberUpper|Phone
emailOrLoginUpper|E-mail (login)
passwordConfirmationUpper|Password confirmation
citizenshipUpper|Citizenship
country|country
addressUpper|Address
descriptionUpper|Comment
enterCaptchaUpper|Enter the text from the image (latin symbols)
registerUpper|Register
registerBooking|Book
noRegisterBooking|Without authorization
applicationBooked|The application has been booked, a login and password have been sent to your email to control the booking
wrongNameValue|Incorrect name
wrongSurnameValue|Incorrect surname
wrongPhoneValue|Incorrect phone
wrongPhoneMask|Incorrect phone mask
wrongEmailOrLoginValue|Incorrect e-mail (login)
wrongEmailOrLoginMask|Incorrect e-mail (login) mask
userWithThisEmailOrLoginAlreadyExists|A user with such E-mail/login is already registered in the system. Please log in
wrongPasswordValue|Incorrect Password
passwordDidntAllowedBySecurePolicy|In order to keep your profile safe, please specify at least 6 characters (uppercase and lowercase letters, numbers, or symbols) in the password.
wrongPasswordConfirmation|Incorrect Password confirmation
passwordDoesnotEqualsPasswordConfirmation|Passwords do not match in the fields
wrongCitizenshipValue|Incorrect citizenship
userDoesnotExistInUserList|No such user in the UserList table
wrongCaptchaValue|Invalid verification code
loginError|Log in failed. Please try again.
wrongLicenseFileUpper|Incorrect license file.
megatecUpper|«Megatec Company» LLC
placesInBusOnTour|Seats in a bus for the tour
placesInRailwayOnTour|Seats in the carriage on the tour
contactsUpper|Contacts
moreUpper|More
addHotelInformation|Add. hotel information
quotaHasNoPlaces|No places
onRequest|Seats on request
available|Available
fewPlaces|Few places
placesLeft1|{} places left
placesLeft2|{} places left
placesLeft3|{} places left
enRoute|en route
connection|Connection
details|Details
cancel|Cancel
close|Close
children|children
forward|Forward
backward|Backward
filters|Filters
choose|Choose
selected|Selected
flightUpper2|Flight
transferUpper|Transfer
transfersUpper|Transfers
applyUpper|Apply
titleUpper|Title
noResults|No results found
photoUpper|Photo
accommodationOptions|Accommodation options
cancelWithPenalty|cancellation with penalty
partnerBanText|The partner has been banned: {0}
partnerWarningText|The partner has a warning: {0}
partnerWarningConfirmText|The partner has a warning: {0} Continue booking?
daysNightsHotelAndTravel|{0} hotel {1} + {2} travel {3}
daysNightsTourDuration|Tour duration {0} {1}/{2} {3}
anyUpper|Any
yesUpper|Yes
noUpper|No

#Booking
oneWay|One way
roundTrip|Round trip
date|Date
tariff|Tariff
fromPrice|from
returnUpper|Return
cancellationPolicyInfo|Penalty {0} {1} for cancellation from {2}<br />
cancellationPolicyWithoutPenaltyInfo|Cancellation without penalty till {0}<br />
cancellationPolicyWithNights|Penalty {0} night(s) for cancellation from {1}<br />
passThroughBookingAccessDenied|There is no permission to book services in the external system.  
passThroughBookingAllowCancelation|The number of days for cancellation without penalty is less than 
passThroughBookingAllowCancelationContinue|day(s). Booking in the external system is prohibited.
passThroughBookingSmallDepositeSize|The balance of your deposit is less than 
passThroughBookingSmallDepositeSizeContinue|% of the cost of the service booked in the external system. Booking in the external system is prohibited. 
passThroughBookingOKConfirmation|By clicking “OK” the preliminary booking will be created in the tour operator’s system. After the manager processes the information, the cost can be changed.
passThroughBookingCancelConfirmation|By clicking "Cancel" the preliminary booking will be canceled and you will return to the basket.
NemoUnsuccessfullBooking|Attention! We were unable to book a regular flight. Tour prices and regular flight details are subject to change.{0}Our manager will contact you to clarify the details.
booked|Successfully booked
failed|Unsuccessfully booked
searchFlightTickets|Search flights
notFoundFlights|With the selected search parameters, air travel was not found. Please change the search parameters.
fileNotFoundUpper|Could not find the file specified GDS air database 
folderNotFoundUpper|Could not find folder with file of GDS air database 
requiredFieldNotFilledUpper|Required field is not filled

#Login
logInUpper|Log in
loginOrPasswordErrorUpper|Incorrect username or password.

#Learning mode
learningMode|Learning mode
learningModeFirstTimeText|Before you start booking, here are a few tips to help you make the booking process easier. To re-watch, use the "Learning Mode" link in the upper right corner of the screen.
of|of
back|Back
next|Next
finish|Finish

mobileDevice|Mobile version
desktopDevice|Full screen version

changeDisplayTheme|Change display theme

nameForFilterHeadlineCheckbox|All

#PolicyBlock
importantInfo|Important information
policyVisaInfo|Vias Information
additionalInfo|Additional information

policyBlockChildren|Children
policyBlockForChildren|For children
policyBlockMealsForChildren|Meals for children
policyBlockCot|Baby cot

policyBlockInternet|Internet
policyBlockDeposit|Deposit
policyBlockAccommodations|Accomodarion conditions
policyBlockExtraBed|Extra Bed
policyBlockMeal|Meal
policyBlockParking|Parking
policyBlockAddFee|Additional services
policyBlockShuttle|Transfer
policyBlockAccWithPets|Accommodation with pets

policyBlockPrice|Price
policyBlockAvailability|Availability
policyBlockDirection|Direction
policyBlockService|Service
policyBlockLocation|Location
policyBlockChildrenAcc|Children accommodation
policyBlockMealType|Meal type
policyBlockMaxCount|Max count
policyBlockDepositType|Deposit type


policyVisaDescription|The hotel provides assistance in processing visa documents
policyBlockChildrenTitle|Ages {0} to {1} years must be accommodated in the same room as parents or guardians in extra beds
needsToBeClarified|It is necessary to clarify on the spot
depositTypeKeys|For keys
depositTypePet|For pets
depositTypeBreakage|For possible breakage of property
paymentTypeCard|by card
paymentTypeCash|by cash
priceUnitPerRoomPerNight|for room per night
priceUnitPerRoomPerStay|for room per stay
priceUnitPerGuestPerNight|for guest per night
priceUnitParkingPerGuestPerNight|for car per night
priceUnitPerGuestPerStay|for geust per stay
priceUnitPetsPerGuestPerStay|for pet per stay
priceUnitPetsPerGuestPerNight|for pet per night
priceUnitPerGuest|per guest
priceUnitPerHour|per hour
priceUnitPerWeek|per week

feeTypeTelevision|Television
feeTypeBedLinen|Bed Linen
feeTypeTowelsOnly|Towels
feeTypeConditioning|Air condition
feeTypeRefrigerator|Refrigerator
feeTypeMicrowave|Microwave in room
feeTypeTowels|Towels and linen
feeTypeUnspecified|Check with hotels
feeTypeHousekeeping|Housekeeping
feeTypeHeating|Heating
feeTypeUtility|Utility
feeTypeSafe|Safe
feeTypeLuggageStorage|Luggage storage
feeTypeTourGuide|Tour guide
feeTypeBicycleRental|Bicycle rental
feeTypeBabyHighchair|Baby highchair
feeTypeLuggageStorageApartment|Luggage storage apartment
feeTypeLuggageStorageOffice|Luggage storage office

mealTypeBreakfast|Breakfast
mealTypeAllInclusive|All Inclusive
mealTypeBreakfastBuffet|Breakfast-buffet
mealTypeContinentalBreakfast|Continental breakfast
mealTypeDinner|Dinner
mealTypeFullBoard|Full Board
mealTypeHalfBoard|Half Board
mealTypeLunch|Lunch
mealTypeNoMeal|No meal
mealTypeSomeMeal|Meal
mealTypeEnglishBreakfast|English breakfast
mealTypeAmericanBreakfast|American breakfast
mealTypeAsianBreakfast|Asian breakfast
mealTypeChineseBreakfast|Chinese breakfast
mealTypeIsraeliBreakfast|Israeli breakfast
mealTypeJapaneseBreakfast|Japanese breakfast
mealTypeScandinavianBreakfast|Scandinavian breakfast
mealTypeScottishBreakfast|Scottish breakfast
mealTypeBreakfastFor1|Breakfast for 1 person
mealTypeBreakfastFor2|Breakfast for 2 person
mealTypeSuperAllInclusive|Super All Inclusive
mealTypeSoftAllInclusive|Soft All Inclusive
mealTypeUltraAllInclusive|Ultra All Inclusive
mealTypeHalfBoardLunch|Half Board (Lunch)
mealTypeHalfBoardDinner|Half Board (Dinner)

internetTypeWireless|Wireless
internetTypeWired|Wired

childrenMealFromGuest|per guest
childrenMealTitle|(child from {0} to {1} years old)
workAreaRoom|In room
workAreaHotel|In lobby

destinationTypeTrain|Railway station
destinationTypeAirport|Airport
destinationTypeAirportTrain|Aeroexpress train
destinationTypeShip|Ship
shuttleTypeOneWay|One way
shuttleTypeTwoWays|Two ways

petsTypeUnspecified|Any pets are allowed
petsTypeGt5kg|Pets greater than 5 kg
petsTypeLt5kg|Pets less than 5 kg

forFree|For free
territoryTypeOnside|On the territory
territoryTypeOffside|Outside of the territory

#Penalty and Total price information
penaltiesUponRequestRow|<span style="background-color: bisque;border-radius: 2px;">Penalties - on request</span>
penaltiesUponRequestCard|<span style="color: coral">Penalties - on request</span>
cancellationPolicyWithoutPenaltyInfoRow|Cancellation <span style="background-color: #90ee907d;border-radius: 2px;">without penalty</span> till {0}<br />
cancellationPolicyInfoRow|<span style="background-color: bisque;border-radius: 2px;">Penalty</span> {0} {1} for cancellation from {2}<br />
cancellationPolicyWithNightsRow|<span style="background-color: bisque;border-radius: 2px;">Penalty</span> {0} night(s) for cancellation from {1}<br />
cancellationPolicyWithoutPenaltyInfoCard|Cancellation <span style="color: #90ee907d">without penalty</span> till {0}<br />
cancellationPolicyInfoCard|<span style="color: coral">Penalty</span> {0} {1} for cancellation from {2}<br />
cancellationPolicyWithNightsCard|<span style="background-color: coral">Penalty</span> {0} night(s) for cancellation from {1}<br />
penaltiesExist|Penalties exist
penaltiesNotExist|No penalties have been set 
showPenalties|Show penalties
showTotalPrice|Show total prices
summaryLower|total
InformationMessageBookingHotelOnlyMT|Penalties have already been imposed on this hotel; to make a reservation, you must contact the manager
`;
